class DlFormCustomer extends HTMLElement {
    constructor() {
        super();

        this.inputs = this.querySelectorAll('input');
    }

    connectedCallback() {
        this.bindEvents();
        setTimeout(() => this.checkInputActive(), 200);
    }

    bindEvents() {
        this.inputs.forEach(input => {
            input.addEventListener('input', event => this.updateActiveState(event.target));
        });
    };

    checkInputActive() {
        this.inputs.forEach(input => {
            this.updateActiveState(input);
            console.log(input.value, 'tetet');
        });
        console.log('huey')
    }

    updateActiveState(input) {
        if (input && input.value) {
            input.classList.add('active');
        } else {
            input.classList.remove('active');
        }
    }
}

customElements.define('dl-form-customer', DlFormCustomer);

class DlFormCustomerLogin extends DlFormCustomer {
    constructor() {
        super();

        this.email_input = this.querySelector('#CustomerEmail');
        this.password_input = this.querySelector('#CustomerPassword');

        this.div_button = this.querySelector('.dl-customer-login-button');
        this.button = this.querySelector('#dl-customer-login-button');
        this.remember_cbx = this.querySelector('#rememberPsw');

        this.getRemember();
    }

    bindEvents() {
        super.bindEvents();
        this.div_button.addEventListener('click', this.submit.bind(this));
    };

    submit() {
        if (this.remember_cbx.checked) {
            this.setRemember();
        } else {
            this.removeRemember();
        }
        this.button.click();
    }

    setRemember() {
        let email = this.email_input.value;
        let password = this.password_input.value;
        localStorage.setItem('dl-login-email', email);
        localStorage.setItem('dl-login-password', password);
    }

    getRemember() {
        let email = localStorage.getItem('dl-login-email');
        let password = localStorage.getItem('dl-login-password');
        if (email != null && password != null) {
            this.email_input.value = email;
            this.password_input.value = password;
        }
    }

    removeRemember() {
        localStorage.setItem('dl-login-email', '');
        localStorage.setItem('dl-login-password', '');
    }
}

customElements.define('dl-form-customer-login', DlFormCustomerLogin);
